import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';
import { DatabaseIndice, DatabaseRelation } from '../alcance/interfaces/database';

@Injectable({
  providedIn: 'root'
})
export default class PendenciaDBService extends DatabaseService {
    override classname: string = 'PendenciaDBService';
    override table = 'pendencia';
    override keyPath = 'uuid';
    override typeKey = 'TEXT';
    protected override useUuidKey = true;

    protected override migration: number = 2;

    override indices: DatabaseIndice[] = [
        {name: "by_id", field: "id", unique: false, multiEntry: false},
        {name: "by_edificacao", field: "andar.edificacao_id", unique: false, multiEntry: false},
        {name: "by_descricao", field: "descricao", unique: false, multiEntry: false},
        {name: "by_status", field: "status", unique: false, multiEntry: false},
        {name: "by_categoria", field: "categoria", unique: false, multiEntry: false},
        {name: "by_sinc", field: "sinc", unique: false, multiEntry: false}
    ];

    protected override relations: DatabaseRelation[] = [
        {name: 'atividade', table: 'atividade', field: 'atividade_id', type: 'foreign', key:'atividade'},
        {name: 'andar', table: 'andar', field: 'andar_id', type: 'foreign'},
        {name: 'usuario', table: 'usuario', field: 'usuario_id', type: 'foreign'},
        {name: 'operador', table: 'usuario', field: 'operador_id', type: 'foreign'},
    ];

    protected override filterSql(sql: string, params: any): string {
        if(params?.descricao){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            sql += " by_descricao LIKE '%" + params.descricao + "%'";
        }
        if(params?.categoria){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            sql += " by_categoria = '" + params.categoria + "'";
        }
        if(params?.status){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            sql += " by_status = '" + params.status + "'";
        }

        return sql;
    }
}
